import { state, materialState, pickerState, turkish } from "./controls/state.js"
import { carPaintProps, getCarPaintProps, getCarPaintPalette, glassPaintProps, getGlassPaintProps, getGlassPaintPalette } from "./paint/paint.js"
import { CirclePicker, SwatchesPicker } from "react-color"
import { useSnapshot } from "valtio"
import * as material from 'material-colors'
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";

const windowTags = ["front_side_glass", "front_glass", "back_side_glass", "back_glass"]

function Picker() {
  const snap = useSnapshot(state)
  const pickerSnap = useSnapshot(pickerState)

  if (snap.current === "car_paint") {
 
    const optionsBrand = Object.keys(carPaintProps)
    const optionsSeries = Object.keys(carPaintProps[pickerSnap.items[snap.current].brand])

    return (
      <>
        <div style={{ display: turkish[snap.current] ? "block" : "none" }}>
          <CirclePicker
            colors={getCarPaintPalette(pickerSnap.items[snap.current].brand, pickerSnap.items[snap.current].series)}
            className="circle_picker"
            onChange={(color, event) => {
                state.items[snap.current] = color.hex;
                materialState.items[snap.current] = getCarPaintProps(pickerSnap.items[snap.current].brand, pickerSnap.items[snap.current].series, color.hex).material;
                
                console.log(color)
                console.log(getCarPaintProps(pickerSnap.items[snap.current].brand, pickerSnap.items[snap.current].series, color.hex).material)
                return true
              }}
          />
        </div>
        <div >
          <div class="brand_selector">
            <Dropdown
              options={optionsBrand}
              value={pickerSnap.items[snap.current].brand}
              onChange={(selected) => {
                state.items[snap.current] = "#ffffff";
                materialState.items[snap.current] = "01_default"
                pickerState.items[snap.current].brand = selected.value;
                pickerState.items[snap.current].series = Object.keys(carPaintProps[selected.value])[0];
                return true
              }}
              placeholder="Select an option"
            />
          </div>
          <div class="series_selector">
            <Dropdown
              options={optionsSeries}
              value={pickerSnap.items[snap.current].series}
              onChange={(selected) => {
                state.items[snap.current] = "#ffffff";
                materialState.items[snap.current] = "01_default"
                pickerState.items[snap.current].series = selected.value;
                return true
              }}
              placeholder="Select an option"
            />
          </div>
        </div>
      </ >
    )
  } else if (windowTags.includes(snap.current)) {

    const gOptionsBrand = Object.keys(glassPaintProps)
    const gOptionsSeries = Object.keys(glassPaintProps[pickerSnap.items[snap.current].brand])

    return (
      <>
        <div style={{ display: turkish[snap.current] ? "block" : "none" }}>
          <SwatchesPicker
            colors={getGlassPaintPalette(pickerSnap.items[snap.current].brand, pickerSnap.items[snap.current].series)}
            className="swatches_picker"
            height="130px"
            onChange={(color, event) => {
                state.items[snap.current] = color.hex;
                materialState.items[snap.current] = getGlassPaintProps(pickerSnap.items[snap.current].brand, pickerSnap.items[snap.current].series, color.hex).material;
                return true
              }}
          />
        </div>
        <div >
          <div class="brand_selector">
            <Dropdown
              options={gOptionsBrand}
              value={pickerSnap.items[snap.current].brand}
              onChange={(selected) => {
                state.items[snap.current] = "#ffffff";
                materialState.items[snap.current] = "01_default"
                pickerState.items[snap.current].brand = selected.value;
                pickerState.items[snap.current].series = Object.keys(glassPaintProps[selected.value])[0];
                return true
              }}
              placeholder="Select an option"
            />
          </div>
          <div class="series_selector">
            <Dropdown
              options={gOptionsSeries}
              value={pickerSnap.items[snap.current].series}
              onChange={(selected) => {
                state.items[snap.current] = "#ffffff";
                materialState.items[snap.current] = "01_default"
                pickerState.items[snap.current].series = selected.value;
                return true
              }}
              placeholder="Select an option"
            />
          </div>
        </div>
      </ >
    )
  } else {
    return (<></>)
  }

}

function PickerDesc () {

  //const snap = useSnapshot(state, { sync: true })
  const snap = useSnapshot(state)
  const pickerSnap = useSnapshot(pickerState)

  if (snap.current === "car_paint") {
    
    /*
    const color = snap.items[snap.current]
    
    const name = paintProps.name;
    */



    return (
        <div class="item_desc">
          <h3 style={{ color: "black " }}>{turkish[snap.current]}</h3>
          <h2 style={{ color: "black " }}>{getCarPaintProps(pickerSnap.items[snap.current].brand, pickerSnap.items[snap.current].series, snap.items[snap.current]).display}</h2>
        </div>
    )
  }  else if (windowTags.includes(snap.current)) {

    return (
    <div class="item_desc">
      <h3 style={{ color: "black " }}>{turkish[snap.current]}</h3>
      <h2 style={{ color: "black " }}>{ getGlassPaintProps(pickerSnap.items[snap.current].brand, pickerSnap.items[snap.current].series, snap.items[snap.current]).display }</h2>
    </div>
    )
  } else {
    return (<></>)
  }
}

export { Picker, PickerDesc }